import styled from 'styled-components/macro';
import { variables } from 'theme/variables';
import { Row } from '@zendeskgarden/react-grid';

const { color_grey_200: colorGrey200, color_blue_700: colorBlue700 } =
  variables;

export const PipeFactsStatus = styled.div`
  display: flex;
  background: ${colorGrey200};
  justify-content: center;
  border-radius: 0.5em;
  height: 460px;
  margin: 10px 0;
  flex-direction: row;
  flex-wrap: wrap;
  @media (max-width: 780px) {
    width: 100%;
  }
  @media (max-width: 500px) {
    height: 490px;
  }
`;

export const Stages = styled(Row)`
  ul {
    padding: 5px;
  }
  .stage {
    display: flex;
    color: #999;
  }
  .stage_icon {
    position: relative;
    padding: 0 1.5em;
    z-index: 2;
    right: 0;
    top: 0;
    transform: translateX(50%);
    border-radius: 50%;
    background-repeat: no-repeat;
    background-position: center center;
    width: 50px;
    height: 50px;
    box-shadow: 1px 1px 7px -2px ${colorBlue700};

    @media (max-width: 1024px) {
      width: 40px;
      height: 40px;
    }
  }
  .stage_title {
    position: relative;
    padding: 0.6em 1.9em 3em 3.25em;
    @media (max-width: 1447px) {
      padding: 0.6em 1.8em 3em 3em;
    }
    @media (max-width: 1268px) {
      padding: 0.5em 1.4em 2.5em 2.25em;
    }
    @media (max-width: 1081px) {
      padding: 0.5em 1.4em 1.8em 2.25em;
    }
    @media (max-width: 780px) {
      padding: 0.9em 1.9em 3.25em 3.25em;
    }
  }
  .stage_title:not(.Certified.Report)::before {
    content: '';
    position: absolute;
    z-index: 1;
    left: 0;
    height: 100%;
    border-left: 2px #ccc solid;
  }
  .stageText {
    font-size: 1.2rem;
    width: 100%;
    @media (max-width: 1240px) {
      font-size: 0.9rem;
    }
    @media (max-width: 1200px) {
      line-height: 16px;
      margin-bottom: 5px;
    }
    @media (max-width: 1070px) {
      font-size: 0.7rem;
    }
    @media (max-width: 780px) {
      font-size: 1rem;
    }
  }
  .stage_status {
    display: flex;
    width: 100%;
    justify-content: flex-start;
    font-size: 14px;
    line-height: 15px;
    @media (max-width: 1240px) {
      font-size: 12px;
    }
    @media (max-width: 1070px) {
      font-size: 10px;
    }
    @media (max-width: 780px) {
      font-size: 12px;
    }
  }
  @media (max-width: 780px) {
    .stage_list {
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      justify-content: center;
    }
    display: flex;
    justify-content: center;
    .stage {
      margin-left: 110px;
    }
  }
  @media (max-width: 610px) {
    .stage {
      margin-left: 10%;
    }
  }
`;
